var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "merged-page" },
    [
      _c(
        "AppBreadCrumb",
        {
          attrs: {
            paths: [{ title: _vm.$t("message.bannedVisitors") }],
            select: true,
          },
        },
        [
          _c("a-input-search", {
            staticClass: "search-input",
            attrs: { placeholder: _vm.$t("message.startFilter") },
            on: { search: _vm.onSearch },
            model: {
              value: _vm.searchText,
              callback: function ($$v) {
                _vm.searchText = $$v
              },
              expression: "searchText",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "d-flex w-100",
          staticStyle: { "background-color": "#ffffff" },
        },
        [
          _c(
            "div",
            {
              staticClass: "side-menubar-wrapper",
              staticStyle: { width: "15%" },
            },
            [_c("UsersMenu")],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { id: "banned-visitors" } },
            [
              _c(
                "b-container",
                { attrs: { fluid: "" } },
                [
                  _c("a-table", {
                    staticClass: "custom-table2",
                    attrs: {
                      columns: _vm.cols(),
                      dataSource: _vm.getFilteredRows(),
                      loading: _vm.isBusy,
                      locale: {
                        emptyText: _vm.$t("message.noBannedVisitorFound"),
                      },
                      pagination: false,
                      rowKey: "_id",
                    },
                    on: { change: _vm.tableChange },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "connectionTimeSlot",
                          fn: function (data, item) {
                            return _c("div", {}, [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm._f("date")(item.connectionTime)) +
                                  "\n                    "
                              ),
                            ])
                          },
                        },
                        {
                          key: "actionsSlot",
                          fn: function (data, item) {
                            return _c(
                              "div",
                              { key: "actionsSlot" + _vm.$i18n.locale },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex w-100 justify-content-start",
                                  },
                                  [
                                    _vm.isRoot ||
                                    _vm.user.role.permissions
                                      .map(function (x) {
                                        return x.name
                                      })
                                      .includes("visitor.unblock")
                                      ? _c(
                                          "a-button",
                                          {
                                            directives: [
                                              {
                                                name: "tippy",
                                                rawName: "v-tippy",
                                                value: {
                                                  followCursor: true,
                                                  placement: "bottom-end",
                                                  theme: _vm.isDarkMode
                                                    ? "light-border"
                                                    : "google",
                                                },
                                                expression:
                                                  "{\n                                    followCursor: true,\n                                    placement: 'bottom-end',\n                                    theme: isDarkMode ? 'light-border' : 'google',\n                                }",
                                              },
                                            ],
                                            staticClass: "tableActionButton",
                                            attrs: {
                                              content: _vm.$t(
                                                "message.removeBanDescription"
                                              ),
                                              shape: "circle",
                                              size: "small",
                                              type: "primary",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.unban(item._id)
                                              },
                                            },
                                          },
                                          [
                                            _c("font-awesome-icon", {
                                              attrs: {
                                                icon: "unlock-alt",
                                                size: "sm",
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ]
                            )
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "mt-3 d-flex justify-content-end" },
                    [
                      _c("Pagination", {
                        attrs: {
                          "page-change": _vm.pageChange,
                          "page-sizes": _vm.pageSizes,
                          total: _vm.bannedVisitors.total,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      !_vm.isAdmin ? _c("ChatBar", { attrs: { visible: false } }) : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }